
<template>
  <div class="wrap talk re-style">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <template v-if="isWaitData">
          <article class="certification">
            <section class="txt return">
              <p class="return-txt">
                주문 정보 확인중입니다
                <br />
              </p>
            </section>
          </article>
        </template>
        <template v-if="isInqueryData">
            <ResultInfo
              :noAiImg="noAiImg"
              :resInfo="resInfo"
              :isRegDone="isRegDone"
              @changeDntnInfo="handleButtnClick"
            />
        </template>
        <template v-if="isNotData">
          <article class="certification">
            <section class="txt return">
              <p class="return-txt">
                주문 정보를 확인하지 못했습니다
                <br />
                잠시 후 다시 시도해 주세요
                <br />
                또는
                <span>
                  <a href="tel: 1877-5446">
                    고객센터
                  </a>
                </span>
                에 문의 바랍니다
              </p>
            </section>
          </article>
        </template>
        <template v-if="isDone">
          <article class="certification">
            <section class="txt">
				<h2>{{statmsg}}</h2>
			</section>
            <section class="txt aconfirm">
              <p class="aconfirm-txt" v-html="doneMsg"/>
            </section>
          </article>
          <div id="regBtnDiv" class="ui-buttons">
            <ul class="ui-buttons__list" v-if="resInfo.spsl_amt != '0' && resInfo.add_cmp_amt == 0 && statmsg == '판매 완료'">
              <li class="ui-buttons__item" style="display:contents;">
                <button
                  type="button"
                  class="ui-button ui-basic-button"
                  style="background:#F0F0F0;"
                  @click="handleButtnClick('D')"
                >
                  닫기
                </button>
                <button
                  type="button"
                  class="ui-button ui-basic-button"
                  @click="handleButtnClick('A')"
                >
                  All 보상 신청하기
                </button>
              </li>
              </ul>
              <ul class="ui-buttons__list" v-else>
	              <li class="ui-buttons__item">
	                <button
	                  type="button"
	                  class="ui-button ui-basic-button"
	                  @click="handleButtnClick('D')"
	                >
	                  확인
	                </button>
	              </li>
	            </ul>          
          </div>
        </template>
        <div class="cs-center row row_ac row_jsc">
          <span class="qa">고객센터 문의 </span>
          <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
        </div>
      </main>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import AppConfig from '@/config'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import ResultInfo from './components/ResultInfo.vue'

export default {
  name: 'MintitHomeRslt',
  components: {
    DxRequiredRule,
    ResultInfo
  },
  data: () => ({
    isWaitData: true,
    isInqueryData: false,
    isRegDone: true,
    isDone:false,
    isNotData: false,
    isAgree: true,
    isCncl: false,
    noAiImg: false,
    resInfo: {
      img_url: '',
      imagePath: '',
      gd_price: '',
      code_name: '',
      ptnm_nm: '',
      add_cmp_amt_list: [],
      discount_list: [],
      discount_last: '',
      total_price: 0,
      add_cmp_amt: 0,
      atm_display_popup_titles: '',
      spsl_amt: '0',
      rsn_ctt:'',
      dlv_fee_tp:''
    },
    doneMsg:``,
    statmsg:'판매 완료'
  }),
  computed: {
    getOrderNumber () {
      return this.$route.query.ordNum
    }
  },
  created () {
    var img = 'https://d11o63lgw0n6wa.cloudfront.net/images/model/' + this.orderModel + '.png'
  },
  mounted () {
    this.getOrderInfo()
  },
  watch: {
    isEnable (newVal) {
      if (document && newVal) {
        const regBtnDiv = document.getElementById('regBtnDiv')
        if (regBtnDiv) {
          const trgtHeight = regBtnDiv.offsetTop + 87
          window.scrollTo(0, trgtHeight)
        }
      }
    }
  },
  methods: {
    async getOrderInfo () {
      const params = {
        ordNum: this.getOrderNumber
      }
      await Vue.httpClient
        .post('/api/purchase/pcs/mgmt/public/mintit/home/rslt', params)
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            this.isWaitData = false
            this.isInqueryData = true
            if (res.data.result) {
              const rs = res.data.result
              
              if(rs.discount_list.length > 0) {
              	for(let i=0;i < rs.discount_list.length;i++) {
              		if(i == rs.discount_list.length-1) {
              			this.resInfo.discount_last = rs.discount_list[i]
              		} else {
              			this.resInfo.discount_list[i] = rs.discount_list[i]
              		}	
              	}
              }
              
              if(rs.add_cmp_amt_list.length > 0) {
              	for(let i=0;i < rs.add_cmp_amt_list.length;i++) {
              		rs.add_cmp_amt_list[i].add_cmp_amt = (parseFloat(rs.add_cmp_amt_list[i].add_cmp_amt.toString().replace(/,/g, '')) || 0).toLocaleString('en-US')
              		if(this.resInfo.atm_display_popup_titles == '') {
              			this.resInfo.atm_display_popup_titles = rs.add_cmp_amt_list[i].atm_display_popup_title
              		} else {
              			this.resInfo.atm_display_popup_titles = this.resInfo.atm_display_popup_titles +','+ rs.add_cmp_amt_list[i].atm_display_popup_title
              		}           		
              	}
              }
              this.resInfo.spsl_amt = (parseFloat(rs.spsl_amt.toString().replace(/,/g, '')) || 0).toLocaleString('en-US')
              this.resInfo.add_cmp_amt_list = rs.add_cmp_amt_list
              this.resInfo.add_cmp_amt = Number(rs.add_cmp_amt)
              this.resInfo.total_price = Number(rs.add_cmp_amt) + Number(rs.gd_price)
              this.resInfo.total_price = (parseFloat(this.resInfo.total_price.toString().replace(/,/g, '')) || 0).toLocaleString('en-US')
              this.resInfo.rsn_ctt = rs.rsn_ctt
              this.resInfo.dlv_fee_tp = rs.dlv_fee_tp
			
              // 모델용 이미지 img_url
              const img = 'https://d11o63lgw0n6wa.cloudfront.net/images/model/' + rs.order_model + '.png'
              this.resInfo.img_url = img
              this.resInfo.ptnm_nm = rs.ptnm_nm

              // 이미지 없으면
              if (rs.ai_result_image_path) {
                this.resInfo.ai_result_image_path = rs.ai_result_image_path
                this.resInfo.ai_result_code_name = rs.ai_result_code_name

                // 2번째
                if (rs.ai_result_image_path2) {
                  this.resInfo.ai_result_image_path2 = rs.ai_result_image_path2
                  this.resInfo.ai_result_code_name2 = rs.ai_result_code_name2
                }

              } else {
                this.noAiImg = true
              }


              this.resInfo.code_name = rs.code_name
              this.resInfo.gd_price = (parseFloat(rs.gd_price.replace(/,/g, '')) || 0).toLocaleString('en-US')
              this.resInfo.ord_number = this.getOrderNumber

              // 날짜
              const date = new Date(rs.reg_dt)
              const options = { year: 'numeric', month: 'long', day: 'numeric', locale: 'ko-KR' }
              this.resInfo.reg_dt = date.toLocaleDateString('ko-KR', options).replace(/(\d+)년 (\d+)월 (\d+)일/, '$1년 $2월 $3일')

              // 검수완료상태 아니면 버튼영역 hidden
              this.isRegDone = rs.stat_cd !== 'D'
            } else {
            // Vue.Alert.alert("구매 데이터가 없습니다.")
              this.content = '판매이력이 없습니다.'
            }
          } else {
          // alert("1111")

            this.content = '통신오류입니다.'
          }
        }).catch(e => {
          this.isWaitData = false
          this.isNotData = true
          if (e.data && e.data.result) {
            Vue.Alert.alert(e.data.result.message)
          } else {
            Vue.Alert.alert('오류가 발생하였습니다')
          }
        })
    },
    closeWindow () {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('kakaotalk') > -1) {
        if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1) {
          window.location.href = 'kakaoweb://closeBrowser'
        } else {
          window.location.href = 'kakaotalk://inappbrowser/close'
        }
      } else if (window) {
        if (window.opener) {
          window.opener.close()
        }
        window.close()
      }
    },
    async handleButtnClick (e) {
      var $this = this
      if (e === 'D') {
        this.closeWindow()
        return
      }
      
      if (e === 'A') {
        window.open("https://www.mintit.co.kr/reward_2509?go-button=eventApply", "_blank");
        return
      }

      if( e === 'C'){

        // 일반폰, 재협의 사유 확인 후 착불 메세지 처리
        const subMsg = (this.resInfo.dlv_fee_tp === 'PR')
          ? '지금이 가장 높은 시세일 수 있어요'
          : '취소하면 착불 반송 처리돼요 ';

        const msg = `
          <h3>정말 취소할까요?</h3>
          <div style="font-size: 14px; font-weight: 400; line-height:18px;">
            <br>
            ${subMsg}
          </div>
        `
        const isTrue = await $this.$Alert.customSelect(msg,true,'취소할게요','돌아가기')
      	if (!isTrue) return		
      }
      
      const params = {
        ordNum: this.getOrderNumber
      }
      const agrmUrl = '/api/purchase/pcs/mgmt/public/mintit/home/agrm'
      const cnclUrl = '/api/purchase/pcs/mgmt/public/mintit/home/cncl'
      const agrmRedi = 'homeSaleAgrm'
      const cnclRedi = 'homeSaleCncl'
      const url = (e === 'S') ? agrmUrl : cnclUrl
      const trgtRouter = (e === 'S') ? agrmRedi : cnclRedi
      await Vue.httpClient
        .post(url, params)
        .then(res => {
          $this.isInqueryData = false
          $this.isDone = true
          if(e === 'S'){
            $this.doneMsg = `
              <span>민팃해 주셔서 감사해요 </span>
            ` 
            if($this.resInfo.add_cmp_amt == 0 && $this.resInfo.spsl_amt != '0') {
            	$this.doneMsg = $this.doneMsg + `
              	  <br />
	              <span class="aconfirm-boldtxt">All 보상 신청하면 신청 당일</span>
	              <br />
	              <span class="aconfirm-boldtxt">추가보상금을 지급해 드려요!</span>
	              <br />
	              <br />
	              <span class="aconfirm-boldtxt3">아래&nbsp;</span><span class="aconfirm-boldtxt2">[All 보상 신청하기]</span><span class="aconfirm-boldtxt3">&nbsp;버튼을 눌러 진행해 주세요</span>`
            }
            
             $this.doneMsg = $this.doneMsg + `<br />
             <br />
              판매대금 지급을 위한 계좌번호 입력은
              <br />
              알림톡으로 안내드릴게요`
          } else {
            $this.doneMsg = `
              <span>판매 취소가 접수됐어요</span>
              <br />
              진던 결과가 만족스럽지 않으셨나요?
              <br />
              남겨주신 주소로 중고폰을 반송해 드릴게요
              <br />
              다음엔 더 나아진 민팃으로 찾아뵐게요 :) 
            `
            $this.statmsg = `판매 취소`
          }
        }).catch(e => {
          if (e.data && e.data.result) {
            Vue.Alert.alert(e.data.result.message)
          } else {
            Vue.Alert.alert('오류가 발생하였습니다')
          }
          return
        })
    },
    handleImageOnLoad (e) {
      URL.revokeObjectURL(e.target.src)
    },
    handleImagePathError (e) {
      // e.target.src = require(`@/assets/images/no-image.png`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/home/MintitHomeRslt.vue